import _ from 'underscore';

export default class GoogleAutocomplete {
  /**
   * @class AutocompleteProviderBase
   * @classdesc This is an autocomplete provider base
   * @memberof core.components.autocomplete.providers
   * @abstract
   * @constructs
   * @param {object} conf - The conf provided by json
   * @param {Widget} widget - The widget where the Autocomplete will be built
   */
  constructor(conf, widget) {
    this.conf = _.extend({
      minLength: 1
    }, conf);
  }
  /**
   * Override this method if we don't want to use the provider in a specific case
   * @memberOf AutocompleteProviderBase
   */
  validate() {
    return true;
  }

  /**
   * Method to search the source predictions
   * @abstract
   * @memberOf AutocompleteProviderBase
   * @param {string} text - The text to search in source
   */
  getPredictions(text) {
    throw new Error('This method must be implemented');
  }

  /**
   * Set an icon in function of the result
   * @abstract
   * @memberOf AutocompleteProviderBase
   * @param {object} result - The result of search
   */
  getIconClass(result) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/components/autocomplete/providers/AutocompleteProviderBase.js